$("body").on('click', '.related-products .product a', function (e) {
    e.preventDefault();
    let url = $(this).attr('href');
    if (url) {
        window.location.href = url;
    }
});
